import { hexToRgba, makeStyles } from '@surveycake/rc';
import { isInIframe, userAgent } from 'config/system';

export const useStyles = makeStyles([
  [
    'overlay',
	theme => `
		:lang(ar) > div{
			transform: scaleX(-1);
			direction: rtl;
		}

		:lang(ar) footer {
			transform: scaleX(-1);
			direction: rtl;
		}
		display: flex;
		justify-content: center;
		align-items: center;
		position: ${userAgent.isIOSVersionBelow12 && isInIframe ? 'absolute' : 'fixed'};
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 2000;
		background-color: ${hexToRgba(theme.color.text.B6, 0.7)};
	`
  ],
  [
    'modal',
    theme => `
		background-color: ${theme.color.text.white};
		border-radius: 4px;
	`
  ]
]);
